<template>
    <div class="UserAgreement xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-text">
                <h3>在线付费服务协议</h3>
                <!-- <p>Ge Ren XI YI</p> -->
            </div>
        </div>
        <div class="agreement-box">
            <div class="agreement-tit">
                <h3>在线付费服务协议</h3>
            </div>
            <div class="agreement-content">
                 <div class="disclaimer-container">
                        <div class="disclaimer-content">
                        <p>欢迎您使用千越医助手平台，对于您对本平台的支持与理解，致以最诚挚的感谢！</p>

                        <h3 class="title">一、名词解释</h3>
                        <p>千越医助手平台：指包括千越医助手网站、移动客户端App、小程序，以及其他现有或将来要推出的其他平台，（以下简称“平台”或“本平台”）。</p>
                        <p>用户：指已经成功注册千越医助手平台会员，并享受平台提供服务的单位或者个人，（以下简称为“您”）。</p>
                        <p>《在线付费服务协议》（以下简称“本协议”）。</p>
                        
                        <h3 class="title">二、告知说明</h3>
                        <p>本协议是您享受平台收费服务，并通过平台支付费用时，务必知晓并同意的条款、规则。</p>
                        <p>请您在确认支付前，务必认真阅读本协议，充分理解本协议各项容，如您对内容有任何疑问，可向平台客服联系。</p>
                        <p>如您是18周岁以下的未成年人，或着是任何形式的无民事行为能力的人，请在父母或监护人的陪同下阅读本协议</p>
                        <p>当您成功支付平台提供的收费服务时，说明您已充分阅读、理解并接受本协议的全部内容，且接受和遵守接受本协议的全部条款。如您对本协议的任何内容有疑问，及时向平台客服联系并停止支付行为。</p>

                        <h3 class="title">三、支付规则</h3>
                        <p>平台提供的收费服务包括快速问诊、电话问诊、商城购物、收费视频、挂号预约、门诊开方等，以及将来推出的其他收费服务，具体收费方式及收费标准，按照实际功能的显示价格为准。</p>
                        <p>收费服务的价格可能会根据市场供需情况、实际运营情况等进行调整，您须留意服务的价格变化，并根据自主意愿选择适合您的服务。</p>
                        <p>您支付的费用是平台、医生等为您提供服务的劳动所得，与线下实体医院的收费项目、服务无关。</p>
                        <p>当您支付成功时，即表示该服务正式生效，直到服务完成，无正当理由，平台不支持您随意退款，请您务必知晓并理解。</p>
                        <p>平台收费服务为非标准化服务，会出现根绝不同地域、不同用户群体等，收费标准不一致，请您理解与知晓。</p>
                        
                        <h3 class="title">四、其他公告</h3>
                        <p>1.国家相关法律法规规定会出现变化，以及平台运营的过程中，本协议会进行不定期修改、调整。修改后的内容，一旦在平台上发布即生效，并代替原来的内容，您务必及时关注各种变更详情。如您继续使用本平台，即视为您已知晓并同意新的变更内容。</p>
                        <p>2.您除了遵守本协议外，仍需要同时遵守平台的其他协议内容，本协议中没有明确约定，而平台其他协议中有约定的，同样具有法律效应，请您知晓。</p>
                        <p>3.平台拥有对收费服务以及收费标准的最终解释权。</p>
                        
                        <div class="footer-space"></div>
                        </div>
                    </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "UserAgreement",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .UserAgreement{
        background: #f4f4f4;
    }
    .xi .banner{
        height: 116px;
        background: url("../../assets/img/jbk_banner.png")center no-repeat;
    }
    .banner-text{
        width: 1200px;
        margin: 0 auto;
    }
    .banner-text h3{
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }
    .banner-text p{
        font-size: 18px;
        color: #ffffff;
    }
    .agreement-box {
        margin: 30px auto;
        width: 1200px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #e5e5e5;
    }
    .agreement-tit{
        padding: 10px 0 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    .agreement-tit h3{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
    }
    .agreement-content{
        padding: 25px 0;
    }
    .agreement-content p{
        text-indent: 28px;
        line-height: 2;
    }
    .agreement-content p.s-p{
        text-indent: 42px;
    }
    .agreement-content h4{
        text-indent: 28px;
        line-height: 1.7;
        padding: 15px 0;
    }
    .disclaimer-container {
  /* background-color: #f5f5f5; */
  min-height: 100vh;
  padding: 20px 0;
}

.disclaimer-content {
  background-color: #fff;
  padding: 24px;
  margin: 0 auto;
  /* max-width: 800px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  color: #666;
  /* line-height: 1.6; */
}

.disclaimer-content p {
  margin: 12px 0;
  text-indent: 2em;
  text-align: justify;
}

.title {
  font-weight: 800;
  padding: 20px 0 10px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  margin: 24px 0 16px 0;
}

.footer-space {
  width: 100%;
  height: 50px;
}
</style>

